import { ADMIN, DISTRIBUTOR, SELLER } from '@/util/constants/roles';

/**
 *  READ BEFORE USE: Avoid using this functions to check if a user has privileges
 * The correct way to enable/disable features is using permissions for each feature
 *
 */

export function isAdmin(user) {
  return user.data.role.name === ADMIN;
}

export function isDistributor(user) {
  return user.data.role.name === DISTRIBUTOR;
}

export function isSeller(user) {
  return user.data.role.name === SELLER;
}

export default {};
